import { Slice } from "@reduxjs/toolkit";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type GenericState<S> = {
  value: S;
};

export function createGenericSlice<S>(
  sliceName: string,
  initialState: GenericState<S>
): Slice {
  const slice: Slice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
      setState: (state, action: PayloadAction<any>) => {
        state.value = action.payload;
      },
    },
  });

  return slice;
}
